import { useEffect } from 'react';

let count = 0;
let handlers = new Set();
let _isTouchDevice = false;
let _isUsingMouse = true;

// event handlers
const onTouchStart = () => {
	const wasTouchDevice = _isTouchDevice;
	document.removeEventListener('touchstart', onTouchStart, false);
	_isTouchDevice = true;
	if (wasTouchDevice !== _isTouchDevice) {
		runHandlers();
	}
};
const onMouseDown = () => {
	const wasUsingMouse = _isUsingMouse;
	_isUsingMouse = true;
	if (wasUsingMouse !== _isUsingMouse) {
		runHandlers();
	}
};
const onKeyDown = () => {
	const wasUsingMouse = _isUsingMouse;
	_isUsingMouse = false;
	if (wasUsingMouse !== _isUsingMouse) {
		runHandlers();
	}
};

// exposed singleton methods
const isTouchDevice = () => _isTouchDevice;
const isUsingMouse = () => _isUsingMouse;
const isUsingKeyboard = () => !_isUsingMouse; // XXX: we could improve to exclude shift/ctrl/cmd/alt
// XXX: an improvement here could be to detect (guess) if we are using fingers!
//       @see https://codeburst.io/the-only-way-to-detect-touch-with-javascript-7791a3346685
//       @see https://stackoverflow.com/a/18001239
// const isUsingFinger = () => {};

const runHandlers = () => {
	handlers.forEach((handler) => {
		handler({
			touch: isTouchDevice(),
			mouse: isUsingMouse(),
			keyboard: isUsingKeyboard(),
		});
	});
};

/**
 * Know how the user interacts with the website (mouse, keyboard,…)
 */
export default function useInputDevice(handler = undefined) {
	useEffect(() => {
		count++; // increment count of mounted components using this hook

		if (typeof handler !== 'undefined') {
			handler({
				touch: isTouchDevice(),
				mouse: isUsingMouse(),
				keyboard: isUsingKeyboard(),
			});
			handlers.add(handler);
		}

		if (document && count === 1) {
			document.addEventListener('touchstart', onTouchStart);
			document.addEventListener('mousedown', onMouseDown);
			document.addEventListener('keydown', onKeyDown);
		}

		// cleanup
		return () => {
			count--; // increment count of mounted components using this hook

			if (typeof handler !== 'undefined') {
				handlers.delete(handler);
			}

			if (document && count === 1) {
				document.removeEventListener('touchstart', onTouchStart);
				document.removeEventListener('mousedown', onMouseDown);
				document.removeEventListener('keydown', onKeyDown);
			}
		};
	}, [handler]);

	return { isTouchDevice, isUsingMouse, isUsingKeyboard };
}
